import * as React from "react";

export class Title extends React.Component<{ text: string, class: string }, {}> {

    render() {
        return (
            <div className={this.props.class}>{this.props.text}</div>
        )
    }
}